import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import Title from '../Title';
import {EmailInput} from '../EmailInput';
import LargeButton from '../LargeButton';

import './index.scss';

class EmailBody extends PureComponent {

    static get boundFunctions() {
        return [
            'onInputChange',
            'onMailSubmit'
        ];
    }

    constructor(props) {
        super(props);

        this.state = {
            emailInput: ''
        };

        this.constructor.boundFunctions.forEach((fn) => this[fn] = this[fn].bind(this));
    }

    onInputChange(e) {
        this.setState({
            emailInput: e.target.value
        });
    }

    onMailSubmit() {
        this.props.onSendMail(this.state.emailInput);
    }


    render() {
        const {emailTitle} = this.props;
        const {emailInput} = this.state;
        return (
            <div className="email-body">
                <Title title={emailTitle}/>
                <form>
                    <label htmlFor="share-email">{ i18n.t('sharing_link.invite.send_to') }</label>
                    <EmailInput onChange={this.onInputChange} value={emailInput}/>
                    <LargeButton onClick={this.onMailSubmit}>{ i18n.t('sharing_link.button.send') }</LargeButton>
                </form>
            </div>
        );
    }
}

EmailBody.propTypes = {
    emailTitle: PropTypes.string.isRequired,
    onSendMail: PropTypes.func.isRequired
};

export default EmailBody;



// WEBPACK FOOTER //
// ./src/components/EmailBody/index.js